import { formatDateTime, type DigestAudience, type DigestSettings } from '@dataroom/shared';

/** ISO weekdays, 1 = Monday … 7 = Sunday (the API's `dayOfWeek`). */
export const DIGEST_DAYS: { value: number; label: string }[] = [
  { value: 1, label: 'Monday' },
  { value: 2, label: 'Tuesday' },
  { value: 3, label: 'Wednesday' },
  { value: 4, label: 'Thursday' },
  { value: 5, label: 'Friday' },
  { value: 6, label: 'Saturday' },
  { value: 7, label: 'Sunday' },
];

export const DIGEST_AUDIENCE_LABELS: Record<DigestAudience, string> = {
  admin: 'Room admin',
  deal_team: 'Deal team',
  seller: 'Seller',
  buyer: 'Buyer',
};

/** 0–23 as the app writes a time of day: 0 → "12:00 AM", 13 → "1:00 PM". */
export function hourLabel(hour: number): string {
  const h12 = hour % 12 === 0 ? 12 : hour % 12;
  return `${h12}:00 ${hour < 12 ? 'AM' : 'PM'}`;
}

/** An instant shown in the ROOM's timezone ("Mon, Oct 12, 2026, 8:00 AM"); an
 * unknown zone falls back to the viewer's local time. */
export function formatInZone(iso: string, timeZone: string): string {
  try {
    return new Intl.DateTimeFormat('en-US', {
      timeZone,
      weekday: 'short',
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
    }).format(new Date(iso));
  } catch {
    return formatDateTime(iso);
  }
}

/** The PUT body: exactly the seven settings fields, nothing else. */
export function digestSettingsBody(s: DigestSettings): DigestSettings {
  return {
    enabled: s.enabled,
    dayOfWeek: s.dayOfWeek,
    hourOfDay: s.hourOfDay,
    sendToAdmin: s.sendToAdmin,
    sendToDealTeam: s.sendToDealTeam,
    sendToSeller: s.sendToSeller,
    sendToBuyers: s.sendToBuyers,
  };
}

export function sameDigestSettings(a: DigestSettings, b: DigestSettings): boolean {
  return JSON.stringify(digestSettingsBody(a)) === JSON.stringify(digestSettingsBody(b));
}
